import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
import niceScroll from "jquery.nicescroll";

Swiper.use([Navigation, Pagination]);

export default class Scripts {
	constructor() {
		/**
		 * App
		 *
		 * Frontend application
		 */

		;(function (window, $, undefined) {

			'use strict';

			var app = {},
				version = '1.0.4';


			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 * Avoids console errors for browser not supporting console
			 * http://stackoverflow.com/a/13817235/146253
			 */
			function _avoidConsoleErrors() {
				if (!window.console) {
					window.console = {};
				}
				var methods = [
					'log', 'info', 'warn', 'error', 'debug', 'trace', 'dir', 'group', 'groupCollapsed', 'groupEnd', 'time',
					'timeEnd', 'profile', 'profileEnd', 'dirxml', 'assert', 'count', 'markTimeline', 'timeStamp', 'clear'
				];

				var noop = function () {
				};

				for (var i = 0; i < methods.length; i++) {
					if (!window.console[methods[i]]) {
						window.console[methods[i]] = noop;
					}
				}
			}

			/**
			 * String utils
			 */
			function _stringUtils() {

				/**
				 * Add format() to String prototype (sprintf() alike)
				 * http://stackoverflow.com/a/4673436/146253
				 */
				if (!String.prototype.format) {
					String.prototype.format = function () {
						var args = arguments;
						return this.replace(/{(\d+)}/g, function (match, number) {
							return typeof args[number] != 'undefined' ? args[number] : match;
						});
					};
				}
			}

			/**
			 * Array utils
			 */
			function _arrayUtils() {

				/**
				 *  Remove an element from array
				 */
				if (!Array.prototype.remove) {
					Array.prototype.remove = function () {
						var what, a = arguments, L = a.length, ax;
						while (L && this.length) {
							what = a[--L];
							while ((ax = this.indexOf(what)) !== -1) {
								this.splice(ax, 1);
							}
						}
						return this;
					};
				}
			}

			/**
			 * Init data holder
			 */
			function _initData() {
				app.customData = {};
			}

			/**
			 * Init application
			 */
			function _init() {
				_initData();
				_avoidConsoleErrors();
				_stringUtils();
				_arrayUtils();
			}


			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 * Get application version
			 */
			app.getVersion = function () {
				return version;
			};

			/**
			 * Wrapper to $(document).ready()
			 */
			app.ready = function (callable) {
				$(document).ready(callable);
			};

			/**
			 * Run application modules
			 */
			app.module = function () {
				$.each($.makeArray(arguments), function (index, module) {
					window.App[module].run();
				});
			};

			/**
			 * Add arbitrary object to App namespace
			 */
			app.data = function (name, object) {
				if (object === undefined) {
					return app.customData[name];
				}
				app.customData[name] = object;
			};

			/**
			 * Add X-CSRF-Token header to ajax request.
			 * to be used in beforeSend() method
			 *
			 * @param request
			 */
			app.addCsrfTokenHeader = function (request) {
				request.setRequestHeader(
					"X-CSRF-Token",
					$('meta[name="csrf-token"]').attr('content')
				);
			};

			/**
			 *  Returns view port dimension
			 */
			app.getViewportDimensions = function () {
				return {width: $(window).width, height: $(window).height};
			};

			/**
			 * Init and inject into global (window) scope
			 */
			_init();
			window.App = app;

		}(window, $));
		/**
		 * Page Transition
		 *
		 * Handle transitions between pages
		 *
		 * Based on http://tympanus.net/codrops/2013/05/07/a-collection-of-page-transitions/
		 *
		 */
		!(function (app, $, window, document, undefined) {

			'use strict';

			var module = {},
				$ui = {},

				defaultOptions = {
					ui: {}
				},
				isAnimating = false,
				endCurrPage = false,
				endNextPage = false,
				// support css animations
				support = Modernizr.cssanimations;

			// Declare other private  variables here ...

			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			function _init() {
				_data();
				_defineUI();
				_setupEventListeners();
			}

			function _data() {
				// url = $domElement.data('url');
			}

			function _defineUI() {
				// $ui.trigger = $domElement.find(module.options.ui.trigger);
				$ui.switchBtn = $('.js-switch-page');
				$ui.periodeMenu = $('.menu-periode');
			}

			function _setupEventListeners() {
				// $ui.trigger.on('click', _onLoadMore);
				$(document).on('click', '.js-switch-page', function (e) {
					_switchPage(e);
				})
			}

			function _switchPage(evt) {
				evt.preventDefault();

				if (isAnimating) {
					return false;
				}


				isAnimating = true;

				var nextPage = $(evt.target).data('page'),
					animation = $(evt.target).data('animation'),
					$currPage = $('.pt-page-current'),
					$nextPage = $(nextPage).addClass('pt-page-current'),
					outClass = '',
					inClass = '';


				if (nextPage === '#periode1' || nextPage === '#periode2' || nextPage === '#periode3' || nextPage === '#periode4') {
					var itemToSelect = '.menu-item:eq(' + ((nextPage.substr(nextPage.length - 1)) - 1) + ')',
						periodeNb = $(itemToSelect).find('.item-number').html(),
						periodeTitle = $(itemToSelect).find('.item-title').html();

					$ui.periodeMenu.find('.page-number').html(periodeNb);
					$ui.periodeMenu.find('.page-title').html(periodeTitle);
					$ui.periodeMenu.addClass('show');
				} else {
					$ui.periodeMenu.removeClass('show');
				}

				$('.scroll-to-top').removeClass('show');
				App.doubleScroll.scrollToTopActive = false;

				switch (animation) {

					case 1:
						outClass = 'pt-page-moveToLeft';
						inClass = 'pt-page-moveFromRight';
						break;
					case 2:
						outClass = 'pt-page-moveToRight';
						inClass = 'pt-page-moveFromLeft';
						break;
					case 3:
						outClass = 'pt-page-moveToTop';
						inClass = 'pt-page-moveFromBottom';
						break;
					case 4:
						outClass = 'pt-page-moveToBottom';
						inClass = 'pt-page-moveFromTop';
						break;
					case 5:
						outClass = 'pt-page-fade';
						inClass = 'pt-page-moveFromRight pt-page-ontop';
						break;
					case 6:
						outClass = 'pt-page-fade';
						inClass = 'pt-page-moveFromLeft pt-page-ontop';
						break;
					case 7:
						outClass = 'pt-page-fade';
						inClass = 'pt-page-moveFromBottom pt-page-ontop';
						break;
					case 8:
						outClass = 'pt-page-fade';
						inClass = 'pt-page-moveFromTop pt-page-ontop';
						break;
					case 9:
						outClass = 'pt-page-moveToLeftFade';
						inClass = 'pt-page-moveFromRightFade';
						break;
					case 10:
						outClass = 'pt-page-moveToRightFade';
						inClass = 'pt-page-moveFromLeftFade';
						break;
					case 11:
						outClass = 'pt-page-moveToTopFade';
						inClass = 'pt-page-moveFromBottomFade';
						break;
					case 12:
						outClass = 'pt-page-moveToBottomFade';
						inClass = 'pt-page-moveFromTopFade';
						break;
					case 13:
						outClass = 'pt-page-moveToLeftEasing pt-page-ontop';
						inClass = 'pt-page-moveFromRight';
						break;
					case 14:
						outClass = 'pt-page-moveToRightEasing pt-page-ontop';
						inClass = 'pt-page-moveFromLeft';
						break;
					case 15:
						outClass = 'pt-page-moveToTopEasing pt-page-ontop';
						inClass = 'pt-page-moveFromBottom';
						break;
					case 16:
						outClass = 'pt-page-moveToBottomEasing pt-page-ontop';
						inClass = 'pt-page-moveFromTop';
						break;
					case 17:
						outClass = 'pt-page-scaleDown';
						inClass = 'pt-page-moveFromRight pt-page-ontop';
						break;
					case 18:
						outClass = 'pt-page-scaleDown';
						inClass = 'pt-page-moveFromLeft pt-page-ontop';
						break;
					case 19:
						outClass = 'pt-page-scaleDown';
						inClass = 'pt-page-moveFromBottom pt-page-ontop';
						break;
					case 20:
						outClass = 'pt-page-scaleDown';
						inClass = 'pt-page-moveFromTop pt-page-ontop';
						break;
					case 21:
						outClass = 'pt-page-scaleDown';
						inClass = 'pt-page-scaleUpDown pt-page-delay300';
						break;
					case 22:
						outClass = 'pt-page-scaleDownUp';
						inClass = 'pt-page-scaleUp pt-page-delay300';
						break;
					case 23:
						outClass = 'pt-page-moveToLeft pt-page-ontop';
						inClass = 'pt-page-scaleUp';
						break;
					case 24:
						outClass = 'pt-page-moveToRight pt-page-ontop';
						inClass = 'pt-page-scaleUp';
						break;
					case 25:
						outClass = 'pt-page-moveToTop pt-page-ontop';
						inClass = 'pt-page-scaleUp';
						break;
					case 26:
						outClass = 'pt-page-moveToBottom pt-page-ontop';
						inClass = 'pt-page-scaleUp';
						break;
					case 27:
						outClass = 'pt-page-scaleDownCenter';
						inClass = 'pt-page-scaleUpCenter pt-page-delay400';
						break;
					case 28:
						outClass = 'pt-page-rotateRightSideFirst';
						inClass = 'pt-page-moveFromRight pt-page-delay200 pt-page-ontop';
						break;
					case 29:
						outClass = 'pt-page-rotateLeftSideFirst';
						inClass = 'pt-page-moveFromLeft pt-page-delay200 pt-page-ontop';
						break;
					case 30:
						outClass = 'pt-page-rotateTopSideFirst';
						inClass = 'pt-page-moveFromTop pt-page-delay200 pt-page-ontop';
						break;
					case 31:
						outClass = 'pt-page-rotateBottomSideFirst';
						inClass = 'pt-page-moveFromBottom pt-page-delay200 pt-page-ontop';
						break;
					case 32:
						outClass = 'pt-page-flipOutRight';
						inClass = 'pt-page-flipInLeft pt-page-delay500';
						break;
					case 33:
						outClass = 'pt-page-flipOutLeft';
						inClass = 'pt-page-flipInRight pt-page-delay500';
						break;
					case 34:
						outClass = 'pt-page-flipOutTop';
						inClass = 'pt-page-flipInBottom pt-page-delay500';
						break;
					case 35:
						outClass = 'pt-page-flipOutBottom';
						inClass = 'pt-page-flipInTop pt-page-delay500';
						break;
					case 36:
						outClass = 'pt-page-rotateFall pt-page-ontop';
						inClass = 'pt-page-scaleUp';
						break;
					case 37:
						outClass = 'pt-page-rotateOutNewspaper';
						inClass = 'pt-page-rotateInNewspaper pt-page-delay500';
						break;
					case 38:
						outClass = 'pt-page-rotatePushLeft';
						inClass = 'pt-page-moveFromRight';
						break;
					case 39:
						outClass = 'pt-page-rotatePushRight';
						inClass = 'pt-page-moveFromLeft';
						break;
					case 40:
						outClass = 'pt-page-rotatePushTop';
						inClass = 'pt-page-moveFromBottom';
						break;
					case 41:
						outClass = 'pt-page-rotatePushBottom';
						inClass = 'pt-page-moveFromTop';
						break;
					case 42:
						outClass = 'pt-page-rotatePushLeft';
						inClass = 'pt-page-rotatePullRight pt-page-delay180';
						break;
					case 43:
						outClass = 'pt-page-rotatePushRight';
						inClass = 'pt-page-rotatePullLeft pt-page-delay180';
						break;
					case 44:
						outClass = 'pt-page-rotatePushTop';
						inClass = 'pt-page-rotatePullBottom pt-page-delay180';
						break;
					case 45:
						outClass = 'pt-page-rotatePushBottom';
						inClass = 'pt-page-rotatePullTop pt-page-delay180';
						break;
					case 46:
						outClass = 'pt-page-rotateFoldLeft';
						inClass = 'pt-page-moveFromRightFade';
						break;
					case 47:
						outClass = 'pt-page-rotateFoldRight';
						inClass = 'pt-page-moveFromLeftFade';
						break;
					case 48:
						outClass = 'pt-page-rotateFoldTop';
						inClass = 'pt-page-moveFromBottomFade';
						break;
					case 49:
						outClass = 'pt-page-rotateFoldBottom';
						inClass = 'pt-page-moveFromTopFade';
						break;
					case 50:
						outClass = 'pt-page-moveToRightFade';
						inClass = 'pt-page-rotateUnfoldLeft';
						break;
					case 51:
						outClass = 'pt-page-moveToLeftFade';
						inClass = 'pt-page-rotateUnfoldRight';
						break;
					case 52:
						outClass = 'pt-page-moveToBottomFade';
						inClass = 'pt-page-rotateUnfoldTop';
						break;
					case 53:
						outClass = 'pt-page-moveToTopFade';
						inClass = 'pt-page-rotateUnfoldBottom';
						break;
					case 54:
						outClass = 'pt-page-rotateRoomLeftOut pt-page-ontop';
						inClass = 'pt-page-rotateRoomLeftIn';
						break;
					case 55:
						outClass = 'pt-page-rotateRoomRightOut pt-page-ontop';
						inClass = 'pt-page-rotateRoomRightIn';
						break;
					case 56:
						outClass = 'pt-page-rotateRoomTopOut pt-page-ontop';
						inClass = 'pt-page-rotateRoomTopIn';
						break;
					case 57:
						outClass = 'pt-page-rotateRoomBottomOut pt-page-ontop';
						inClass = 'pt-page-rotateRoomBottomIn';
						break;
					case 58:
						outClass = 'pt-page-rotateCubeLeftOut pt-page-ontop';
						inClass = 'pt-page-rotateCubeLeftIn';
						break;
					case 59:
						outClass = 'pt-page-rotateCubeRightOut pt-page-ontop';
						inClass = 'pt-page-rotateCubeRightIn';
						break;
					case 60:
						outClass = 'pt-page-rotateCubeTopOut pt-page-ontop';
						inClass = 'pt-page-rotateCubeTopIn';
						break;
					case 61:
						outClass = 'pt-page-rotateCubeBottomOut pt-page-ontop';
						inClass = 'pt-page-rotateCubeBottomIn';
						break;
					case 62:
						outClass = 'pt-page-rotateCarouselLeftOut pt-page-ontop';
						inClass = 'pt-page-rotateCarouselLeftIn';
						break;
					case 63:
						outClass = 'pt-page-rotateCarouselRightOut pt-page-ontop';
						inClass = 'pt-page-rotateCarouselRightIn';
						break;
					case 64:
						outClass = 'pt-page-rotateCarouselTopOut pt-page-ontop';
						inClass = 'pt-page-rotateCarouselTopIn';
						break;
					case 65:
						outClass = 'pt-page-rotateCarouselBottomOut pt-page-ontop';
						inClass = 'pt-page-rotateCarouselBottomIn';
						break;
					case 66:
						outClass = 'pt-page-rotateSidesOut';
						inClass = 'pt-page-rotateSidesIn pt-page-delay200';
						break;
					case 67:
						outClass = 'pt-page-rotateSlideOut';
						inClass = 'pt-page-rotateSlideIn';
						break;

				}

				$currPage.addClass(outClass).on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function () {
					$currPage.off('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd');
					endCurrPage = true;
					if (endNextPage) {
						onEndAnimation($currPage, $nextPage);
					}
				});

				$nextPage.addClass(inClass).on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function () {
					$nextPage.off('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd');
					endNextPage = true;
					if (nextPage === "#periodes" && !Modernizr.touch) {
						$('.js-select-slide:first').trigger('click');
					}
					if (endCurrPage) {
						onEndAnimation($currPage, $nextPage);
					}
				});

				if (!support) {

					onEndAnimation($currPage, $nextPage);
				}
			}

			function onEndAnimation($outpage, $inpage) {
				endCurrPage = false;
				endNextPage = false;
				resetPage($outpage, $inpage);
				isAnimating = false;
			}

			function resetPage($outpage, $inpage) {
				$outpage.attr('class', 'pt-page');
				$inpage.attr('class', 'pt-page pt-page-current');
			}

			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 *  Module main method
			 *
			 * @param options
			 */
			module.run = function (options) {
				module.options = $.extend(defaultOptions, options || {});
				$(document).ready(_init);
			};

			/**
			 * Inject module into app
			 */
			app.pageTransition = module;

		}(App, $, window, document));
		/**
		 * Slider
		 *
		 * Module description
		 *
		 */
		;(function (app, $, window, document, undefined) {

			'use strict';

			var module = {
					swiperSlider: '',
					videoDuration: 20000,
					nextTimeout: ''
				},
				$ui = {},

				defaultOptions = {
					ui: {}
				};

			// Declare other private  variables here ...

			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			function _init() {
				_data();
				_defineUI();
				_initSlider();
				_setupEventListeners();
			}

			function _data() {
				// url = $domElement.data('url');
			}

			function _defineUI() {
				$ui.slider = $('#periodes .swiper-container');
				$ui.sliderNav = $('.js-select-slide');
				$ui.globalTimer = $('.global-timer');
				$ui.singleTimer = $ui.sliderNav.find('.timer');
			}

			function _initSlider() {

				module.swiperSlider = new Swiper($ui.slider[0], {
					speed: 1000,
					onlyExternal: true,
				});
			}

			function _setupEventListeners() {
				$ui.sliderNav.on('click', function (e) {
					_manualSlide(e);
				});
				// $('#periodes .video-start').on('click', function(e) {
				//     e.preventDefault();
				//     $(this).parents('.swiper-slide').find('video')[0].play();
				//     if(Modernizr.touch) {
				//         $(this).parents('.swiper-slide').find('.video-start').css('visibility', 'hidden');
				//     }
				// });
			}

			function _manualSlide(evt) {
        

				$('.run-anim .spinner, .run-anim .filler, .run-anim .mask').remove();
				$('.run-anim').prepend('<div class="pie spinner"></div><div class="pie filler"></div><div class="mask"></div>')
					.removeClass('run-anim');

				$ui.sliderNav.removeClass('active');
				clearTimeout(module.nextTimeout);

				if ($(evt.target).hasClass('js-select-slide')) {
					var selectedSlide = $(evt.target);
				} else {
					var selectedSlide = $(evt.target).parent();
				}

				selectedSlide.addClass('active');
				_drawGlobalTimer(selectedSlide.data('slide'));
        module.swiperSlider.slideTo(selectedSlide.data('slide'));
				selectedSlide.find('.timer').addClass('run-anim');


				if (!Modernizr.touch) {
				
					module.nextTimeout = setTimeout(function () {
						if (selectedSlide.data('slide') === 3) {
							$('.js-select-slide:first').trigger('click');
						} else {
							selectedSlide.next().trigger('click');
						}
					}, 20000);
				}
			}

			function _drawGlobalTimer(startPoint) {
				var itemWidth = $ui.sliderNav.width() + 21,
					animateTime = 80000 - (startPoint * module.videoDuration);

				$ui.globalTimer
					.stop()
					.css('width', startPoint * itemWidth)
					.animate({width: '100%'}, animateTime, 'linear');

			}

			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 *  Module main method
			 *
			 * @param options
			 */
			module.run = function (options) {
				module.options = $.extend(defaultOptions, options || {});
				$(document).ready(_init);
			};

			/**
			 * Inject module into app
			 */
			app.slider = module;

		}(App, $, window, document));
		/**
		 * Slideshow
		 *
		 * Slider regroupant les images d'une période
		 *
		 */
		;(function (app, $, window, document, undefined) {

			'use strict';

			var module = {
					swiperSliderTop: '',
					swiperSliderThumbs: '',
					videoDuration: 20000,
					nextTimeout: ''
				},
				$ui = {},

				defaultOptions = {
					ui: {}
				};

			// Declare other private  variables here ...

			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			function _init() {
				_data();
				_defineUI();
				// _initSliders();
				// _initScroll();
				_setupEventListeners();
			}

			function _data() {
				// url = $domElement.data('url');
			}

			function _defineUI() {
				$ui.slideDescription = $('.slide-description');
			}

			function _initSliders(selectedSlideshow, selectedSlide) {
        var xx = $(selectedSlideshow).find('.gallery-top')
				module.swiperSliderTop = new Swiper(xx[0], {
          navigation: {
            nextEl: '.gallery-top-next',
            prevEl: '.gallery-top-prev',
          },
					speed: 1000,
					simulateTouch: false,
					on: {
              init: function (swiper) {
              _initScroll();

              swiper.slideTo(selectedSlide - 1);
              var slide = '#' + $('.gallery-top .swiper-slide-active .slide-description').getNiceScroll(0).id;
              $(slide).find('.nicescroll-cursors').css('background-color', '#fff');
              _playVideo();
            },
            slidePrevTransitionEnd: function () {
              var slide = '#' + $('.gallery-top .swiper-slide-next .slide-description').getNiceScroll(0).id;
              $(slide).find('.nicescroll-cursors').css('background-color', '#191c1e');
            },
            onSlideNextEnd: function () {
              var slide = '#' + $('.gallery-top .swiper-slide-prev .slide-description').getNiceScroll(0).id;
              $(slide).find('.nicescroll-cursors').css('background-color', '#191c1e');
            },
            onSlideChangeEnd: function () {
              var slide = '#' + $('.gallery-top .swiper-slide-active .slide-description').getNiceScroll(0).id;
              $(slide).find('.nicescroll-cursors').css('background-color', '#fff');
              $('.slide-description').getNiceScroll().resize();
              _stopVideo();
            }
          }
				});
        
        
        var xx2 = $(selectedSlideshow).find('.gallery-thumbs')
				module.swiperSliderThumbs = new Swiper(xx2[0], {
          navigation: {
            nextEl: '.gallery-thumbs-nextt',
            prevEl: '.gallery-thumbs-prev',
          },
					speed: 1000,
					spaceBetween: 30,
					simulateTouch: false,
					slidesPerView: 'auto',
					centeredSlides: true,
					initialSlide: selectedSlide -1,
					onInit: function (swiper) {
						$('.gallery-thumbs-buttons').height(swiper.height).css('margin-top', -swiper.height);
						console.log(selectedSlide)
						swiper.slideTo(selectedSlide - 1);
					},
					onImagesReady: function (swiper) {
						swiper.slideTo(selectedSlide - 1);
					}
				});

				module.swiperSliderTop.params.control = module.swiperSliderThumbs;
				module.swiperSliderThumbs.params.control = module.swiperSliderTop;
				module.swiperSliderThumbs.activeIndex = selectedSlide - 1;
			}

			function _initScroll() {
				$('.slide-description').niceScroll({
					cursorcolor: '#fff',
					cursoropacitymin: 0,
					cursoropacitymax: 1,
					cursorborder: '0 none',
					cursorborderradius: 'none'
				});
			}

			function _setupEventListeners() {
				// $ui.trigger.on('click', _onLoadMore);
				$('.js-open-slideshow').on('click', function (evt) {
					var slideshowNb = $(this).data('slideshow'),
						selectedSlideshowFile = 'components/slideshows/html/' + slideshowNb + '.html',
						selectedSlideshowId = '#slideshow-' + slideshowNb,
						selectedSlide = $(this).data('slide');


					$('.slideshow-container').empty().load(selectedSlideshowFile, function () {
						_initSliders(selectedSlideshowId, selectedSlide);
						$(selectedSlideshowId).addClass('open');
					});

          var slideshowNb2 = $(this).data('slideshow'),
          selectedSlideshowFile2 = 'components/slideshows/html_offline/' + slideshowNb2 + '.html',
          selectedSlideshowId2 = '#slideshow-' + slideshowNb2,
          selectedSlide2 = $(this).data('slide');
          _initSliders(selectedSlideshowId2, selectedSlide2);
          $(selectedSlideshowId2).addClass('open');
				});
				$(document).on('click', '.js-close-slideshow', function (e) {
					e.preventDefault();
					$('.slideshow').removeClass('open');
					setTimeout(function () {
						module.swiperSliderTop.destroy(false, true);
						module.swiperSliderThumbs.destroy(false, true);
					}, 500);
				});
				$(document).on('click', '.gallery-thumbs .swiper-slide', function (evt) {
					var selectedSlide = $(this).index();

					module.swiperSliderTop.slideTo(selectedSlide);
					module.swiperSliderThumbs.slideTo(selectedSlide);
				});
        $(document).on('click', '.gallery-top .gallery-top-next', function (evt) {
					var selectedSlide = module.swiperSliderTop.realIndex;
					module.swiperSliderThumbs.slideTo(selectedSlide);
				});
        $(document).on('click', '.gallery-top .gallery-top-prev', function (evt) {
					var selectedSlide = module.swiperSliderTop.realIndex;
					module.swiperSliderThumbs.slideTo(selectedSlide);
				});
			}

			var VideoHandler = {
				play: function ($el) {
					$el[0].contentWindow.postMessage(
						'{"event":"command","func":"' + 'playVideo' + '","args":""}', '*'
					);
					return $el;
				},
				stop: function ($el) {
					$el[0].contentWindow.postMessage(
						'{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*'
					);
					return $el;
				}
			};


			function _playVideo() {

				$('.watch-video').click(function (evt) {
					evt.preventDefault();
					var $videoToPlay = $(this)
						.closest('.swiper-slide')
						.find('iframe');
					VideoHandler.play($videoToPlay)
						.closest('.swiper-slide')
						.find('.video-wrapper')
						.addClass('video-appear');
				});
			}

			function _stopVideo() {
				$('.slideshow iframe').each(function () {
					var $videoToStop = $(this);
					VideoHandler.stop($videoToStop)
						.closest('.video-wrapper')
						.removeClass('video-appear');
				});
			}

			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 *  Module main method
			 *
			 * @param options
			 */
			module.run = function (options) {
				module.options = $.extend(defaultOptions, options || {});
				$(document).ready(_init);
			};

			/**
			 * Inject module into app
			 */
			app.slideshow = module;

		}(App, $, window, document));
		/**
		 * Slider
		 *
		 * Module description
		 *
		 */
		;(function (app, $, window, document, undefined) {

			'use strict';

			var module = {
					scrollToTopActive: false
				},
				$ui = {},

				defaultOptions = {
					ui: {}
				};

			// Declare other private  variables here ...

			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			function _init() {
				_data();
				_defineUI();
				_setupEventListeners();
			}

			function _data() {
				// url = $domElement.data('url');
			}

			function _defineUI() {
			}

			function _setupEventListeners() {
				$('#periode1, #periode2, #periode3, #periode4').on(' scroll', function () {
					if ($(window).width() > 1024) {
						moveDoubleScroll($(this));
					}
					if ($(this).getNiceScroll(0) === false) {
						return
					}
					if (($(this).getNiceScroll(0).getScrollTop() > 1000 && !module.scrollToTopActive) || ($(this).getNiceScroll(0).getScrollTop() < 1000 && module.scrollToTopActive)) {
						$('.scroll-to-top').toggleClass('show');
						module.scrollToTopActive = !module.scrollToTopActive;
					}
				});

				$('.scroll-to-top').on('click', function () {
					$('.pt-page-current').getNiceScroll(0).doScrollTop(0, 5000);
					$(this).removeClass('show');
					module.scrollToTopActive = false;
				});

				$('.js-start-scroll').on('click', function () {
					var selectedPeriode = $(this).data('page');

					$('.pt-page').each(function () {
						if ($(this).getNiceScroll().length) {
							$(this).getNiceScroll(0).remove();
						}
					});

					$(selectedPeriode).niceScroll({
						cursorborder: '0 none',
						cursorborderradius: 'none',
						zindex: 9999,
						smoothscroll: true
					});
					if ($(window).width() > 1024) {
						var currentScrollTop = $(selectedPeriode).getNiceScroll(0).getScrollTop(),
							periodeHeight = $(selectedPeriode).find('.periode-global').height(),
							newPos = currentScrollTop / periodeHeight * 100 + '%';

						$('.double-scroll').css('width', newPos);
					}
				});
			}

			function moveDoubleScroll(evt) {

				var periodeHeight = evt.find('.periode-global').height();
				if (evt.getNiceScroll(0) !== false) {
					var currentScrollTop = evt.getNiceScroll(0).getScrollTop();
				}
				var newPos = currentScrollTop / periodeHeight * 100 + '%';


				$('.double-scroll').css('width', newPos);


			}

			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 *  Module main method
			 *
			 * @param options
			 */
			module.run = function (options) {
				module.options = $.extend(defaultOptions, options || {});
				$(document).ready(_init);
			};

			/**
			 * Inject module into app
			 */
			app.doubleScroll = module;

		}(App, $, window, document));
		/**
		 * Slider
		 *
		 * Module description
		 *
		 */
		;(function (app, $, window, document, undefined) {

			'use strict';

			var module = {},
				$ui = {},

				defaultOptions = {
					ui: {}
				};

			// Declare other private  variables here ...

			/**
			 |--------------------------------------------------------------------------
			 | Private functions
			 |--------------------------------------------------------------------------
			 */

			function _init() {
				_data();
				_defineUI();
				_setupEventListeners();
			}

			function _data() {
				// url = $domElement.data('url');
			}

			function _defineUI() {
			}

			function _setupEventListeners() {
				$('#periode1, #periode2, #periode3, #periode4').on(' scroll', function () {
					if ($(this).getNiceScroll(0) === false) {
						return
					}
					var selectedFrise = $(this).find('.periode-frise'),
						friseHeight = selectedFrise.outerHeight(),
						scrollPos = $(this).getNiceScroll(0).getScrollTop();

					if (scrollPos >= friseHeight) {
						var newTop = scrollPos - friseHeight - 130;
						selectedFrise.css('top', newTop);
					} else {
						selectedFrise.css('top', 0);
					}
				});
			}


			/**
			 |--------------------------------------------------------------------------
			 | Public functions
			 |--------------------------------------------------------------------------
			 */

			/**
			 *  Module main method
			 *
			 * @param options
			 */
			module.run = function (options) {
				module.options = $.extend(defaultOptions, options || {});
				$(document).ready(_init);
			};

			/**
			 * Inject module into app
			 */
			app.stickyFrise = module;

		}(App, $, window, document));
		/**
		 |--------------------------------------------------------------------------
		 |  Bootstrap/launch all frontend scripts
		 |--------------------------------------------------------------------------
		 */

		;(function (app, $) {

			'use strict';

			/**
			 * Run application modules
			 */
			app.module(
				'pageTransition',
				'slider',
				'slideshow',
				'doubleScroll',
				'stickyFrise'
			);

			/**
			 * Application global onReady
			 */


			app.ready(function () {
				var myLazyLoad = new LazyLoad({
					elements_selector: ".lazy"
				});
				if (Modernizr.touch) {
					$('video').attr('poster', 'data:image/gif,AAAA');
				}
				$('.js-open-menu').on('click', function () {
					if ($(this).hasClass('btn-home') || $(this).hasClass('btn-home-icon')) {
						$('.btn-burger').removeClass('is-clicked');
						$('.pop-menu').removeClass('open');
						$('.scroll-to-top').removeClass('show');
					} else {
						$('.btn-burger').toggleClass('is-clicked');
						$('.pop-menu').toggleClass('open');
						$('.scroll-to-top').addClass('show');
					}
				});

				$('body').niceScroll({
					cursorborder: '0 none',
					cursorcolor: "transparent",
					cursoropacitymax: 0,
					scrollspeed: 1,
					smoothscroll: true
				});

				$('.js-start-scroll').on('click', function () {
					var selectedPeriode = $(this).data('page');

					$('.pt-page').each(function () {
						if ($(this).getNiceScroll().length) {
							$(this).getNiceScroll(0).remove();
						}
					});

					$(selectedPeriode).niceScroll({
						cursorborder: '0 none',
						cursorborderradius: 'none',
						zindex: 9999,
						oneaxismousemode: false,
						scrollspeed: 10,
						smoothscroll: true
					});
				});

				$('.periode-intro button').on('click', function () {
					var scrollPos = $(this).parents('.periode-intro').next('.periode-global').offset().top;

					$('.pt-page-current').getNiceScroll(0).doScrollTop(scrollPos, 5000);
				});

				$('#intro .video-start').on('touchstart', function (evt) {
					evt.preventDefault();
					document.getElementById('videoIntro').play();
					if (Modernizr.touch) {
						$('#intro .video-start').css('visibility', 'hidden');
					}
				})

				setTimeout(function () {
					$('body').addClass('loaded');
				}, 2000);
			});

		})(App, $);
	}

}